export default {
    'Integral': '积分榜',
    'Schedule': '赛程',
    'Player': '球员榜',
    'All': '全部',
    'footballer': '球员',
    'team': '球队',
    'assist': '助攻',
    'goal': '进球',
    'TopCcorer': '射手榜',
    'assists': '助攻榜',
    'Sai': '赛',
    'Win/draw/lose': '胜/平/负',
    'Win': '胜',
    'Lose': '负',
    'in/out': '进/失',
    'integration': '积分',
    'confirm': '确认',
    'cancel': '取消',
    'Group Stage': '小组赛',
    'mainTitle': '2023FIFA男篮世界杯',
    'Year': '年',
    'Month': '月',
    'Day1': '日',
    'Day': '天',
    'Hour': '时',
    'Minute': '分',
    'Second': '秒',
    'HT': '半场',
    'QT': '加时',
    'Corner': '角球',
    '90Min': '90分钟',
    'Promotion zone': '晋级区',
    'undetermined': '待定区',
    'thirdGroup': '小组第三位球队排名',
    'firstGroup': '小组赛',
    'secondGroup': '二阶段 分组赛',
    'rankGroup': '17-32名 排位赛',
    'rankNum': '场比赛',
    'rank1': '冠军争夺',
    'rank2': '5-8排位赛',
    'rank21': '5-8排位赛',
    'rank3': '四分之一决赛',
    'rank4': '半决赛',
    'rank5': '决赛',
    'rank6': '季军赛',
    'rank7': '排位赛',
    'rank8': '第5名决赛',
    'rank9': '第7名决赛',
    'Final': '决赛',
    'tbd': '待定',
    'round16': '1/16决赛',
    'round8': '1/8决赛',
    'round4': '1/4决赛',
    'roundSemiFinal': '半决赛/决赛',
    'conntdown': '世界杯决赛倒计时',
    'worldcup': '世界杯倒计时',
    'nodata': '暂无数据',
    'Finish': '已完场',
    'group48': '小组赛48支球队',
    'mute': '静音',
    'unmute': '取消静音',
    'openMini': '开启画中画',
    'sd': '标清',
    'hd': '高清',
    'fullscreen': '全屏',
    'cancelFullscreen': '取消全屏',
    'empty': '暂无数据',
    'loginOut': '登录已过期',
    'refresh': '刷新'
}